import { JoonUIColor, Loader, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import useMailboxStore from "./hooks/useMailboxStore"
import MailItem from "./MailItem"
import ViewMailModal from "./ViewMailModal"
import { useFamilyMailQuery } from "../../../../networking/queries"
import { sortMailByUnreadAndDate } from "../../../../util/mail"

const ChildMailbox = () => {
  const { selectedUserId } = useMailboxStore()
  const { t } = useTranslation()
  const { data: mail, isLoading } = useFamilyMailQuery({
    isUnread: false,
    childId: selectedUserId as number,
  })

  if (isLoading)
    return (
      <div className="flex flex-col items-center justify-center h-1/2">
        <Loader thickness={2} color={JoonUIColor.icon.neutral} size={24} />
      </div>
    )
  if (!mail) return <></>
  if (!selectedUserId) return <></>

  return (
    <div className="flex flex-col overflow-y-auto">
      {mail.length > 0 ? (
        sortMailByUnreadAndDate(mail, selectedUserId).map((mail) => (
          <MailItem key={mail.id} mail={mail} />
        ))
      ) : (
        <div className="flex flex-col items-center justify-center h-full pt-12 gap-2">
          <Typography variant="bodyBold">{t("MAIL_NO_MAIL_YET")}</Typography>
          <Typography variant="body">{t("MAIL_START_CONVERSATION")}</Typography>
        </div>
      )}
      <ViewMailModal />
    </div>
  )
}

export default ChildMailbox
